module.exports = require("@ember/object/mixin");